import { Component, input } from "@angular/core";
import { ExpandableListStyleModel } from "../model/expandable-list-style-model";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-list-element",
  templateUrl: "./list-element.component.html",
  styleUrls: ["./list-element.component.scss"],
  standalone: true,
  imports: [TranslatePipe],
})
export class ListElementComponent {
  readonly id = input("");
  readonly label = input("");
  readonly content = input("");
  readonly useTranslation = input(true);
  readonly style = input<ExpandableListStyleModel>();
  clicked = false;
}
